import React from "react";

import { DarkAppButton } from "../buttons";
import { iHabitCard } from "../types";

export const HabitCard: React.FC<iHabitCard> = ({ title, Icon }) => {
  return (
    <div className="px-3 flex flex-col rounded-md bg-gray-100 w-full ">
      <p className="col-span-2 text-sm flex text-site-blue-dark p-1">
        <span className="mr-2 flex justify-center items-center">{Icon}</span>
        <span>{title}</span>
      </p>
    </div>
  );
};
